export default __webpack_public_path__ + "static/media/alignment-h-right.21f953f7.svg";